import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

export const getFakultas = createAsyncThunk("fakultas/getAll", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get('v1/fakultas');
    return response.data;
});
export const getFakultasById = createAsyncThunk("fakultas/getById", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/fakultas/${id}`);
    return response.data;
});

export const deleteFakultas = createAsyncThunk("fakultas/delete", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    await jwtAuthAxios.delete(`v1/fakultas/${id}`);
    return id;
});

export const saveFakultas = createAsyncThunk("fakultas/save", async({nama,kode,active}) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/fakultas',{
        "kode": kode,
        "nama": nama,
        "active": active,
    });
    return response.data;
});
export const updateFakultas = createAsyncThunk("fakultas/update", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.put('v1/fakultas',request);
    return response.data;
});

const initialState = {
    loading: false,
    dataFakultas : []
}

const fakultasSlice = createSlice({
    name:"fakultas",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
        .addCase(getFakultas.pending, (state) => {
            state.loading = true;
        })
        .addCase(getFakultas.fulfilled, (state, action) => {
            state.dataFakultas = action.payload;
            state.loading = false;
        })
        .addCase(getFakultas.rejected, (state, action) => {
            state.loading = false;
            console.error("Error during getMatkul:", action.error);
        })
    }
})

export const fakultasSelectors = (state) => state.fakultas;
export default fakultasSlice.reducer;